import Button from 'antd/es/button';
import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.marginXS}px;
  margin-bottom: ${({ theme }) => theme.marginLG}px;
  flex-wrap: wrap;
  align-items: center;
`;

export const FilterTag = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.marginXXS}px;
  padding: ${({ theme }) => `${theme.paddingXXS}px ${theme.paddingXS}px`};
  background: ${({ theme }) => theme.colorFillSecondary};
  border: ${({ theme }) => `${theme.lineWidth}px solid ${theme.colorBorder}`};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  font-size: ${({ theme }) => theme.fontSizeSM}px;
  color: ${({ theme }) => theme.colorText};
  transition: all ${({ theme }) => theme.motionDurationMid}
    ${({ theme }) => theme.motionEaseInOut};

  &:hover {
    background: ${({ theme }) => theme.colorFillContent};
    border-color: ${({ theme }) => theme.colorPrimary};
  }
`;

export const FilterTagLabel = styled.span`
  color: ${({ theme }) => theme.colorTextSecondary};
  font-weight: ${({ theme }) => theme.fontWeightStrong};
`;

export const FilterTagValue = styled.span`
  color: ${({ theme }) => theme.colorText};
`;

export const FilterTagClose = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.colorTextTertiary};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.size}px;
  height: ${({ theme }) => theme.size}px;
  border-radius: ${({ theme }) => theme.borderRadiusXS}px;
  margin-left: ${({ theme }) => theme.marginXXS}px;
  transition: all ${({ theme }) => theme.motionDurationMid}
    ${({ theme }) => theme.motionEaseInOut};

  &:hover {
    background: ${({ theme }) => theme.colorFillContent};
    color: ${({ theme }) => theme.colorText};
  }

  &:active {
    background: ${({ theme }) => theme.colorFillSecondary};
  }
`;

export const AddFilterButton = styled(Button)`
  border-style: dashed !important;
  color: ${({ theme }) => theme.colorTextSecondary} !important;
  border-color: ${({ theme }) => theme.colorBorder} !important;

  &:hover {
    color: ${({ theme }) => theme.colorPrimary} !important;
    border-color: ${({ theme }) => theme.colorPrimary} !important;
    background: ${({ theme }) => theme.colorFillQuaternary} !important;
  }
`;

export const ClearAllButton = styled(Button)`
  color: ${({ theme }) => theme.colorTextSecondary} !important;
  border-color: ${({ theme }) => theme.colorBorder} !important;

  &:hover {
    color: ${({ theme }) => theme.colorText} !important;
    border-color: ${({ theme }) => theme.colorTextSecondary} !important;
  }
`;

export const MoreFiltersButton = styled(Button)`
  color: ${({ theme }) => theme.colorTextSecondary} !important;
  border: none !important;
  background: ${({ theme }) => theme.colorFillQuaternary} !important;

  &:hover {
    color: ${({ theme }) => theme.colorPrimary} !important;
    background: ${({ theme }) => theme.colorFillTertiary} !important;
  }
`;

export const FilterDropdownContent = styled.div`
  padding: ${({ theme }) => theme.paddingXS}px;
  min-width: 200px;
`;

export const FilterOptionButton = styled(Button)`
  width: 100%;
  text-align: left;
  justify-content: flex-start;
  margin-bottom: ${({ theme }) => theme.marginXXS}px;
  border: none !important;
  background: transparent !important;
  color: ${({ theme }) => theme.colorText} !important;

  &:hover {
    background: ${({ theme }) => theme.colorFillTertiary} !important;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;
